import {SET_REFILL_ENABLED} from './actions';

export function coreSettings(
  state: Settings,
  {type, payload}: Action = {type: '', payload: {}}
): Settings {
  switch (type) {
    case SET_REFILL_ENABLED:
      return {
        ...state,
        isRefillEnabled: payload.isEnabled,
      };

    default:
      return state;
  }
}
